import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth/useAuth';
import { HeroDeslogado } from './components/HeroDeslogado/HeroDeslogado';
import { HeroLogado } from './components/HeroLogado/HeroLogado';
import { Servicos } from './components/Servicos/Servicos';
import { LojaSerproBanner } from './components/LojaSerproBanner/LojaSerproBanner';
import { StatsBand } from './components/StatsBand/StatsBand';
import { NovidadesRow } from './components/NovidadesRow/NovidadesRow';
import { OpcoesPagamento } from './components/OpcoesPagamento/OpcoesPagamento';
import { Manuais } from './components/Manuais/Manuais';
import styles from './Home.module.scss';

function Home() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { hash } = useLocation();
  const loggedIn = auth?.isAuthenticated ?? false;
  const userName = auth?.user?.name ?? '';

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hash]);

  const handleLogin = () => navigate('/login');

  return (
    <div className={styles.app}>
      {loggedIn ? (
        <>
          <HeroLogado userName={userName} />
          <Servicos variant='logado' />
          <LojaSerproBanner />
          <OpcoesPagamento />
          <Manuais />
        </>
      ) : (
        <>
          <HeroDeslogado onLogin={handleLogin} />
          <Servicos variant='deslogado' />
          <LojaSerproBanner />
          <StatsBand />
          <NovidadesRow />
          <Manuais />
        </>
      )}
    </div>
  );
}

export default Home;
